// components/RouteInterceptor.tsx
import { useRedirect } from 'contexts/redirect/context'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const RouteInterceptor = ({ children }: { children: React.ReactNode }): React.ReactElement => {
    const location = useLocation()
    const { setRedirectUri } = useRedirect()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const redirectUri = params.get('redirectUri')
        if (redirectUri != null) {
            setRedirectUri(redirectUri)
        }
    }, [location.search, setRedirectUri])

    return <>{children}</>
}

export default RouteInterceptor
